import { CSSProperties } from "react";

export const BUTTON_STYLE: CSSProperties = {
  color: "#FFF",
  textAlign: "center",
  fontFamily: "Poppins",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
  letterSpacing: "0.124px",
  backgroundColor: "#1973FF",
  borderRadius: "6px",
  padding: "10px 20px",
  width: "186px",
  height: "40px",
  flexShrink: 0,
};

export function makeid(length: number) {
  let result = "";
  const characters = "abcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let index = 0; index < length; index++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const DEFAULT_EMAILS = {
  [makeid(10)]: "",
  [makeid(10)]: "",
  [makeid(10)]: "",
};

export const FIRST_EMAIL_ID = Object.keys(DEFAULT_EMAILS)[0];
